export default {
  computed: {
    // Return last error
    messages_list: function() { return this.$store.getters.messages; }
  },

  methods: {
    // Add an error
    messages_addError: function(error) { this.$store.commit('addMessage', { type: 'error', text: error }); },

    // Add an info
    messages_addInfo: function(info) { this.$store.commit('addMessage', { type: 'info', text: info }); },

    // Add a warning
    messages_addWarning: function(warning) { this.$store.commit('addMessage', { type: 'warning', text: warning }); },

    // Reset last error
    messages_reset: function() { this.$store.commit('removeMessages', null); },
  },
};